export default "__VITE_ASSET__DYEgQ5I0__"